import {
  clearPendingInvitationToken,
  readPendingInvitationToken,
} from "@/features/auth/lib/storage";
import { X } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export function PendingInvitationBanner() {
  const navigate = useNavigate();
  const [token] = useState(() => readPendingInvitationToken());
  const [dismissed, setDismissed] = useState(false);

  if (!token || dismissed) return null;

  function handleProcess() {
    navigate(`/invitations/accept?t=${token}`);
  }

  function handleDismiss() {
    clearPendingInvitationToken();
    setDismissed(true);
  }

  return (
    <div className="flex items-center justify-between border-primary-500/20 border-b bg-primary-500/10 px-4 py-2">
      <p className="text-primary-300 text-sm">
        Tenés una invitación pendiente.{" "}
        <button type="button" onClick={handleProcess} className="underline hover:text-primary-200">
          Procesarla →
        </button>
      </p>
      <button
        type="button"
        onClick={handleDismiss}
        aria-label="Cerrar banner de invitación"
        className="ml-4 text-primary-300 hover:text-primary-200"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
